import { Injectable } from "@angular/core";
import { UrlTree } from "@angular/router";

import { environment } from "@env/environment";
import { Observable } from "rxjs";

import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(private authService: AuthService) {}

  canActivateChild():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authService.authToken || !this.authService.loggedOut) {
      return true;
    }

    window.location.replace(`${environment.BASE_AUTH_URL}Account/Login`);
    return false;
  }
}
